function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Back",
  fill: "#4658a2",
  d: "M0 0h600v800H0z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Blocks-text"
}, React.createElement("path", {
  fill: "none",
  d: "M41.2 60.4h435.7v679.1H41.2z"
}), React.createElement("text", {
  transform: "translate(41.155 78.249)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 24
}, "Health measures"), React.createElement("tspan", {
  x: 0,
  y: 43,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 24
}, "Adverse Childhood Experiences"), React.createElement("tspan", {
  x: 0,
  y: 86,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 24
}, "Cardiovascular Deaths"), React.createElement("tspan", {
  x: 0,
  y: 129,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 24
}, "Diabetes"), React.createElement("tspan", {
  x: 0,
  y: 172,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 24
}, "Frequent Mental Distress - Seniors"), React.createElement("tspan", {
  x: 0,
  y: 215,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 24
}, "Immunizations - Children"), React.createElement("tspan", {
  x: 0,
  y: 258,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 24
}, "Infectious Disease"), React.createElement("tspan", {
  x: 0,
  y: 301,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 24
}, "Low Birthweight"), React.createElement("tspan", {
  x: 0,
  y: 344,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 24
}, "Maternal Mortality"), React.createElement("tspan", {
  x: 0,
  y: 387,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 24
}, "Mental Health Providers"), React.createElement("tspan", {
  x: 0,
  y: 430,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 24
}, "Obesity"), React.createElement("tspan", {
  x: 0,
  y: 473,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 24
}, "Preventable Hospitalizations"), React.createElement("tspan", {
  x: 0,
  y: 516,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 24
}, "Primary Care Physicians"), React.createElement("tspan", {
  x: 0,
  y: 559,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 24
}, "Stroke"), React.createElement("tspan", {
  x: 0,
  y: 602,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 24
}, "Supportive Neighborhoods"), React.createElement("tspan", {
  x: 0,
  y: 645,
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 24
}, "Uninsured")), React.createElement("path", {
  fill: "none",
  d: "M494.8 60.4h85.1v679.1h-85.1z"
}), React.createElement("text", {
  transform: "translate(494.815 78.249)"
}, React.createElement("tspan", {
  x: 0,
  y: 0,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 24
}, "Rank"), React.createElement("tspan", {
  x: 0,
  y: 43,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 24
}, "30th"), React.createElement("tspan", {
  x: 0,
  y: 86,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 24
}, "34th"), React.createElement("tspan", {
  x: 0,
  y: 129,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 24
}, "41st"), React.createElement("tspan", {
  x: 0,
  y: 172,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 24
}, "36th"), React.createElement("tspan", {
  x: 0,
  y: 215,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 24
}, "33rd"), React.createElement("tspan", {
  x: 0,
  y: 258,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 24
}, "37th"), React.createElement("tspan", {
  x: 0,
  y: 301,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 24
}, "28th"), React.createElement("tspan", {
  x: 0,
  y: 344,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 24
}, "43rd"), React.createElement("tspan", {
  x: 0,
  y: 387,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 24
}, "49th"), React.createElement("tspan", {
  x: 0,
  y: 430,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 24
}, "37th"), React.createElement("tspan", {
  x: 0,
  y: 473,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 24
}, "34th"), React.createElement("tspan", {
  x: 0,
  y: 516,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 24
}, "45th"), React.createElement("tspan", {
  x: 0,
  y: 559,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 24
}, "33rd"), React.createElement("tspan", {
  x: 0,
  y: 602,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 24
}, "48th"), React.createElement("tspan", {
  x: 0,
  y: 645,
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 24
}, "50th")));

var SvgS10MobileColors = function SvgS10MobileColors(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 600 800"
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default "data:image/svg+xml;base64,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";
export { SvgS10MobileColors as ReactComponent };